<form [formGroup]="form">
  <app-tabs>
    <app-tab
      [title]="'connectionpoint.create.general'"
    >
      <div class="flex flex-col">
        <app-input-group>
          <label appLabel>{{ 'connectionpoint.title' | translate }}</label>
          <input
            appInput
            formControlName="identification"
            readonly
            placeholder="{{ 'connectionpoint.form.enterIdentification' | translate }}">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.alternativeIdentification' | translate }}</label>
          <input
            appInput
            formControlName="alternativeIdentification"
            placeholder="{{ 'connectionpoint.form.enterAlternativeIdentification' | translate }}">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.stationsNumber' | translate }}</label>
          <input
            appInput
            formControlName="stationNumber"
            placeholder="{{ 'connectionpoint.form.enterStationsNumber' | translate }}">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.category' | translate }}</label>
          <select appInput
                  formControlName="connectionPointCategoryId">
            <option value="null" selected disabled>{{ 'connectionpoint.form.chooseCategory' | translate }}
            </option>
            @for (item of connectionPointCategoryList; track item.key) {
              <option [value]="item.key">
                {{ item.value }}
              </option>
            }
          </select>
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.description' | translate }}</label>
          <textarea appInput
                    formControlName="description"
                    rows="4"
                    placeholder="{{ 'connectionpoint.form.enterDescription' | translate }}"></textarea>
        </app-input-group>
      </div>
    </app-tab>
    <app-tab
      [title]="'connectionpoint.create.location'"
    >
      <app-address
        [address]="form.get('address')?.value"
        (addressChange)="addressChanged($event)"
      ></app-address>
    </app-tab>
    <app-tab
      [title]="'connectionpoint.key'"
    >
      <div class="flex flex-col" formGroupName="accessKey">
        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.number' | translate }}</label>
          <input
            appInput
            formControlName="number">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.placementType' | translate }}</label>
          <input
            appInput
            formControlName="placementType">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.code' | translate }}</label>
          <input
            appInput
            formControlName="code">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.remarks' | translate }}</label>
          <textarea
            appInput
            rows="3"
            formControlName="remarks"></textarea>
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.facility' | translate }}</label>
          <input
            appInput
            formControlName="facility">
        </app-input-group>
      </div>
    </app-tab>
    @if (connectionPoint?.connectionPointOwnsConnectionRights) {
      <app-tab [title]="'connectionRight.title'">
        <app-connection-right-form
          [form]="connectionRightForm"
          [isExpired]="connectionRightExpired"
          [showTitle]="false">
        </app-connection-right-form>
      </app-tab>
    }
    <app-tab [title]="'connectionpoint.sharedInstallation.title'">
      <div class="flex flex-col">
        <app-input-group>
          <label appLabel>{{ 'connectionpoint.sharedInstallation.hasSharedServiceLine' | translate }}</label>
          <input type="checkbox" appInput formControlName="hasSharedServiceLine">
        </app-input-group>
        <app-input-group>
          <label appLabel>{{ 'connectionpoint.sharedInstallation.hasCollectiveMetering' | translate }}</label>
          <input type="checkbox" appInput formControlName="hasCollectiveMetering">
        </app-input-group>
        <app-input-group>
          <label appLabel>{{ 'connectionpoint.sharedInstallation.numberOfInstallations' | translate }}</label>
          <input appInput type="number" min="1" step="1" formControlName="numberOfInstallations">
        </app-input-group>
        <app-input-group>
          <label appLabel>{{ 'connectionpoint.sharedInstallation.categoryOfInstallations' | translate }}</label>
          <select appSelect formControlName="categoryOfInstallationsId" [collection]="connectionPointCategoryList"></select>
        </app-input-group>
      </div>
    </app-tab>
    <app-tab [title]="'systemServices.title'">
      <app-input-group>
        <label appLabel>{{ 'systemServices.type' | translate }}</label>
        <select appSelect formControlName="systemServicesType" [collection]="systemServiceTypeOptions"></select>
      </app-input-group>
      <app-input-group>
        <label appLabel>{{ 'systemServices.capacity' | translate }}</label>
        <input appInputNumber formControlName="systemServicesCapacity" [decimals]="1" append="kW">
      </app-input-group>
    </app-tab>
  </app-tabs>
</form>
